/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

import { CardViewModel } from 'src/types/view-models/card.view.model';
import { CardRounded, GlyphRight } from '@americanexpress/dls-react';

// stylesheets
import styles from './BwCard.module.scss';

export default class BwCard extends Component<CardViewModel> {
    public override render(): ReactComponentElement<any> {
        const icon = this.props.rightArrow ? <GlyphRight className="right-arrow" /> : null;

        return (
            <CardRounded className={this.getClasses()}>
                {this.props.onClick ? (
                    <button
                        type="button"
                        onClick={() => {
                            if (!this.props.disabled && this.props.onClick) {
                                void this.props.onClick(this.props.object);
                            }
                        }}
                        className="cardInterior"
                    >
                        {icon}
                        {this.props.children}
                    </button>
                ) : (
                    <div className="cardInterior">
                        {icon}
                        {this.props.children}
                    </div>
                )}
            </CardRounded>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        if (this.props.onClick) {
            if (this.props.fullWidth) {
                classes.push(styles.clickableCardFullWidth);
            } else {
                classes.push(styles.clickableCardDefaultWidth);
            }
        } else {
            if (this.props.fullWidth) {
                classes.push(styles.cardFullWidth);
            } else {
                classes.push(styles.cardDefaultWidth);
            }
        }

        return classes.join(' ');
    }
}
